import { useState, type FormEvent } from 'react';

export default function ContactSection() {
  const contactInfo = {
    email: 'contact@51dm.com',
    wechat: '51dongman',
    qq: '800123456',
  };

  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormStatus('idle');
    setFormError('');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      form.reset();
      return;
    }
    formData.delete('website_alt');

    try {
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, String(value));
      });

      const response = await fetch('https://readdy.ai/api/form/d9ku2nohpes2mi34srlg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed && (parsed as Record<string, unknown>).code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg =
          (parsed as Record<string, unknown> | null)?.meta && typeof ((parsed as Record<string, unknown> | null)?.meta as Record<string, unknown>)?.message === 'string'
            ? ((parsed as Record<string, unknown> | null)?.meta as Record<string, unknown>).message as string
            : (parsed as Record<string, unknown> | null)?.message
              ? String((parsed as Record<string, unknown>).message)
              : responseText || '提交失败，请稍后重试';
        setFormError(String(msg));
        setFormStatus('error');
      }
    } catch {
      setFormError('网络错误，请检查连接后重试');
      setFormStatus('error');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            联系我们
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            反馈建议、合作咨询或动漫投稿，欢迎联系51动漫团队
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-10">
            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-6">
                联系方式
              </h3>
              <div className="space-y-5">
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-4 p-4 bg-background-100 rounded-xl hover:bg-primary-50/50 transition-colors cursor-pointer group"
                >
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">电子邮箱</div>
                    <div className="text-sm text-foreground-600">{contactInfo.email}</div>
                  </div>
                </a>

                <div className="flex items-center gap-4 p-4 bg-background-100 rounded-xl group cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">微信公众号</div>
                    <div className="text-sm text-foreground-600">{contactInfo.wechat}</div>
                  </div>
                </div>

                <div className="flex items-center gap-4 p-4 bg-background-100 rounded-xl group cursor-pointer">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100/70 text-secondary-600 group-hover:bg-secondary-500 group-hover:text-background-50 transition-all duration-300">
                    <i className="ri-qq-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-950">QQ客服</div>
                    <div className="text-sm text-foreground-600">{contactInfo.qq}</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
              <h3 className="font-heading text-lg md:text-xl text-foreground-950 mb-6">
                意见反馈
              </h3>
              <form
                data-readdy-form="true"
                id="form-contact-51dm"
                onSubmit={handleSubmit}
              >
                <div className="mb-4">
                  <input
                    type="text"
                    name="name"
                    placeholder="你的昵称"
                    required
                    className="w-full px-4 py-3 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                  />
                </div>
                <div className="mb-4">
                  <input
                    type="email"
                    name="email"
                    placeholder="你的邮箱"
                    required
                    className="w-full px-4 py-3 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
                  />
                </div>
                <div className="mb-4">
                  <textarea
                    name="message"
                    placeholder="请描述你的建议或反馈..."
                    rows={4}
                    maxLength={500}
                    required
                    className="w-full px-4 py-3 bg-background-100 border border-background-300 rounded-lg text-sm text-foreground-900 placeholder-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
                  ></textarea>
                </div>
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
                <button
                  type="submit"
                  className="w-full px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
                >
                  提交反馈
                </button>
                {formStatus === 'success' && (
                  <p className="mt-3 text-sm text-green-600 text-center">反馈已提交，感谢你的宝贵意见！</p>
                )}
                {formStatus === 'error' && (
                  <p className="mt-3 text-sm text-red-500 text-center">{formError}</p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}